// Libraries
import { DefaultTheme } from 'styled-components';

// Layout
import { SeriesColorEnum } from '../layout/elements/LineChart';

// Types
import { EdgeDeviceOperationalStatusStatus } from '../types/global';

/* *************************************** TYPES ********************************************** */

type AggregateValue = { max?: number; avg?: number; min?: number };
type AggregateStatistic = keyof AggregateValue;

/* *************************************** HELPERS ******************************************** */

export const getSeriesThemeColor = (color: string, theme: DefaultTheme): string => {
  const map: Record<string, string> = {
    [SeriesColorEnum.purple]: theme.color.lineChart.seriesColorPurple,
    [SeriesColorEnum.yellow]: theme.color.lineChart.seriesColorYellow,
    [SeriesColorEnum.lightOrange]: theme.color.lineChart.seriesColorLightOrange,
    [SeriesColorEnum.green]: theme.color.lineChart.seriesColorGreen,
    [SeriesColorEnum.orange]: theme.color.lineChart.seriesColorOrange,
    [SeriesColorEnum.blue]: theme.color.lineChart.seriesColorBlue,
    [SeriesColorEnum.pink]: theme.color.lineChart.seriesColorPink,
    [SeriesColorEnum.lightGreen]: theme.color.lineChart.seriesColorLightGreen,
    [SeriesColorEnum.lightPink]: theme.color.lineChart.seriesColorLightPink,
    [SeriesColorEnum.lightBlue]: theme.color.lineChart.seriesColorLightBlue,
  };
  return map[color] || color;
};

export const convertEdgeStatus = (
  status: EdgeDeviceOperationalStatusStatus | number | null | undefined,
): number => {
  let numericStatus: number = 0;

  if (status === EdgeDeviceOperationalStatusStatus.on) {
    numericStatus = 1;
  } else if (typeof status === 'number') {
    numericStatus = status;
  }

  return numericStatus;
};

export const extractValue = (
  value: number | AggregateValue | null | undefined,
  isCondensed: boolean,
  statistic: AggregateStatistic,
): number | null => {
  let result: number | null = null;

  if (value === null || value === undefined) {
    result = null;
  } else if (typeof value === 'number') {
    result = value;
  } else if (isCondensed && typeof value === 'object') {
    result = value[statistic] ?? null;
  }

  return result;
};
